import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Insurance } from "@/components/site/Insurance";
import { Intake } from "@/components/site/Intake";
import { Referrals } from "@/components/site/Referrals";
import { Jobs } from "@/components/site/Jobs";
import { Contact } from "@/components/site/Contact";
import { scrollToId } from "@/lib/api";
import { usePageMeta } from "@/lib/usePageMeta";

export default function Home() {
  usePageMeta(
    "Milestone Pediatric Therapy | Pediatric ABA Therapy",
    "Individualized, family-centered ABA therapy — daily pediatric programs, social skills groups, school & daycare support, and services for children, teens, and adults."
  );
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const t = setTimeout(() => scrollToId(location.state.scrollTo), 700);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <div data-testid="home-page" className="min-h-screen bg-background">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Insurance />
        <Intake />
        <Referrals />
        <Jobs />
        <Contact />
      </main>
    </div>
  );
}
